var _style, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g13, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinningTalents01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.1;fill:#008080;enable-background:new    ;}\n\t.st1{opacity:0.12;fill:#008080;enable-background:new    ;}\n\t.st2{fill:#101B29;}\n\t.st3{fill:#008080;}\n\t.st4{fill:#F3A974;}\n\t.st5{fill:#F99747;}\n\t.st6{fill:#082947;}\n\t.st7{fill:#101C29;}\n\t.st8{fill:url(#SVGID_1_);}\n\t.st9{fill:url(#SVGID_2_);}\n\t.st10{fill:#D5D6D4;}\n\t.st11{fill:#E95C33;}\n\t.st12{fill:#16B4C6;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:#C6C5C5;}\n\t.st15{fill:url(#SVGID_3_);}\n\t.st16{fill:url(#SVGID_4_);}\n\t.st17{fill:#06325D;}\n\t.st18{fill:url(#SVGID_5_);}\n\t.st19{fill:url(#SVGID_6_);}\n\t.st20{fill:url(#SVGID_7_);}\n\t.st21{fill:url(#SVGID_8_);}\n\t.st22{fill:url(#SVGID_9_);}\n\t.st23{fill:#E0E0E0;}\n\t.st24{opacity:0.5;fill:#F5F5F5;enable-background:new    ;}\n\t.st25{fill:#BFBFBF;}\n\t.st26{opacity:0.5;}\n\t.st27{fill:#F5F5F5;}\n\t.st28{fill:url(#SVGID_10_);}\n\t.st29{fill:url(#SVGID_11_);}\n\t.st30{fill:url(#SVGID_12_);}\n\t.st31{opacity:0.75;fill:url(#SVGID_13_);enable-background:new    ;}\n\t.st32{opacity:0.75;fill:url(#SVGID_14_);enable-background:new    ;}\n\t.st33{opacity:0.75;fill:url(#SVGID_15_);enable-background:new    ;}\n\t.st34{opacity:0.75;fill:url(#SVGID_16_);enable-background:new    ;}\n\t.st35{opacity:0.75;fill:url(#SVGID_17_);enable-background:new    ;}\n\t.st36{opacity:0.75;fill:url(#SVGID_18_);enable-background:new    ;}\n\t.st37{opacity:0.75;fill:url(#SVGID_19_);enable-background:new    ;}\n\t.st38{opacity:0.75;fill:url(#SVGID_20_);enable-background:new    ;}\n\t.st39{opacity:0.75;fill:url(#SVGID_21_);enable-background:new    ;}\n\t.st40{opacity:0.75;fill:url(#SVGID_22_);enable-background:new    ;}\n\t.st41{opacity:0.75;fill:url(#SVGID_23_);enable-background:new    ;}\n\t.st42{opacity:0.75;fill:url(#SVGID_24_);enable-background:new    ;}\n\t.st43{opacity:0.75;fill:url(#SVGID_25_);enable-background:new    ;}\n\t.st44{fill:url(#SVGID_26_);}\n\t.st45{opacity:0.75;fill:url(#SVGID_27_);enable-background:new    ;}\n\t.st46{opacity:0.75;fill:url(#SVGID_28_);enable-background:new    ;}\n\t.st47{opacity:0.75;fill:url(#SVGID_29_);enable-background:new    ;}\n\t.st48{opacity:0.75;fill:url(#SVGID_30_);enable-background:new    ;}\n\t.st49{opacity:0.75;fill:url(#SVGID_31_);enable-background:new    ;}\n\t.st50{fill:#FBA210;}\n\t.st51{opacity:0.75;fill:url(#SVGID_32_);enable-background:new    ;}\n\t.st52{opacity:0.75;fill:url(#SVGID_33_);enable-background:new    ;}\n\t.st53{opacity:0.75;fill:url(#SVGID_34_);enable-background:new    ;}\n\t.st54{fill:#222231;}\n\t.st55{fill:#102A54;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.7,504.2c44.8,4.6,89.9,6.4,134.1,7.1c104.3,1.8,208.8-6.7,311.5-25.4c70.6-12.8,131.7-41.8,143.9-118.7 c15.8-99.8-33-225.9-141.9-244.6c-33.7-5.8-68.7-5.5-101-16.6c-48.2-16.4-85.7-55.5-136.7-64.8c-52.1-9.4-110,1.7-151.8,36.6 c-18.4,15.3-34.1,33.3-48.8,52.1c-11.4,14.6-21.9,32.8-39.2,41c-21.2,10.1-45.9,2.1-69.2-1c-39.9-5.3-86.9,7.6-116.7,35.3 C64.7,234.3,55.4,288,59.6,328.3c5.5,52.8,31.6,102.4,76.8,131.6C187.4,492.9,252.8,498.2,311.7,504.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M823.1,222.9c0,178.8-161.6,323.7-361,323.7s-361-144.9-361-323.7S308.8,57.6,508.2,57.6 S823.1,44.1,823.1,222.9z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.1,562.6c0,0-20.3-5.6-21.8-6.2c-1.7-0.5-4.2-1.6-4.6,3.9c-0.4,5.4-0.6,7.1-0.6,7.1s23.6,0.5,26.3,0.3 C373.7,567.4,375.8,565.5,372.1,562.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.9,361.6c0,0,27,63.3,31.9,76.1c4.9,12.9-18.1,26.3-32,13.1c-13.9-13.3-32.8-31.9-40.3-48.4 c-7.4-16.5-9.1-30.9-1.6-46C299.5,341.2,326.7,344.5,333.9,361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.5,442.7c-1.2,16.8-2.3,16.8-4.2,37.1c-2,20.3-7.1,78.9-7.1,78.9s-1.5,1.5-3.1,1.3 c-2.5-0.3-2.9-1.8-2.9-1.8s0-14.5-2.6-24.2c-2.6-9.6-13.3-69.8-15.1-81.8c-1.8-12,1-21.4,14.9-22.4 C360.1,429.1,367,435.4,366.5,442.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.3,376.8c0,0-10.6,66.5-12.1,79.9c-1.6,13.4,23.4,20.7,33.5,4.8c10-15.9,23.6-38.2,26.8-55.5 c3.1-17.5,1.4-31.5-9.4-44C275.3,349.3,250.2,359,247.3,376.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.3,451.4c-5,29.7-17.9,106.8-17.9,106.8s0.1,0.9,2.6,1.4c2.4,0.4,3.2-0.9,3.2-0.9s3.9-12.7,9-20.9 c5.1-8.3,24.7-47.9,29.8-58.6c5.1-10.8,12.7-34.1,0-38.9C250.4,435.4,237.4,444.2,236.3,451.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M369.3,264.5c0,0,11.1-12.6,13.7-16.8c1.9-3.1-2.6-5.3-5.3-6.8c-2.7-1.5-13.1,3.7-20,10.5 C352.3,256.6,367.9,264.9,369.3,264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M323.1,315.5c12.4-6.3,58.5-43.2,58.5-43.2s-1-5.6-6-13.3c-7.3-11.4-13-13.1-13-13.1s-33.2,12.6-51.4,23.5 C306.3,285.6,313.1,320.6,323.1,315.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349,184.5c-1.8-0.2-6.9-0.7-7,0.9c-0.2,3.3,9.4,6.3,13.1,6.5c2.7,0.2,0-3.1,0-3.1S352.7,184.9,349,184.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M383.8,242.1c-1.6-16.6-19.2-46.3-23-55c0.3-4.9-0.1-7.2-1.8-13.3c-1-3.9-5.9-7.2-14.3,3 c-1.5,1.7-0.3,11.9,9.3,13.8c3.5,2.9,10.9,36.8,13.6,47.9c1.3,5,3.7,12.4,7.4,12.4C381.1,251,384.5,248.3,383.8,242.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.3,267.8c30.2,1.8,18.7,24.1,21.9,40c7.4,36.6,19.8,70.2,19.8,70.2s-8.9,16.5-46.5,17.6 c-44.6,1.3-51.7-13.3-51.7-13.3s7.7-93.1,19.8-108.1c2.7-3.5,11-4.7,22.5-6C291.9,267.4,296,267.4,301.3,267.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.1,247.4c7-5.5,10.4-25,0.8-29.3c-11.7-5.3-13.3,7.2-20.4,7.1c-15.4-0.4-19.8,9.4-18.1,21.5 c1,7.5,6.8,14.7,13.3,18.2c2.8,1.5,3.2-11.5,11.1-15.3C307.8,245.8,313.1,247.4,313.1,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.7,269.7c1.4,6.4,6.2,20.3-9.1,19.9c-17.9-0.4-22.2-18.8-21.2-20.9c2.2-4.8,9.3-2.4,13.8-2.2 C297.8,266.7,308.5,264.4,309.7,269.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M284.1,268.3c0.8-0.1,1.8-0.2,2.6-0.2c5-0.3,9,0,14.3,0.5c1.7,0.2,3.2,0.4,4.6,0.8 c0.6,4.1,5,15.5-6.4,15.5C287.6,285,283.9,272.3,284.1,268.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286,268.8c2.7-10.9,5.2-17.7,9-27.1c0-0.3,14.3,2.3,18.2-5c0,0,0.9,9.5-0.5,17.4 c-1.4,7.4-3.6,11.4-10.8,7.7c0,3.7-0.5,7.4,0.3,10.6c1.6,6.2-2.4,8.7-5.4,9C293.7,281.7,283.1,280.3,286,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.2,244.4c-1.2,1.8,0.1,4.5,2.7,6.2s5.6,1.6,6.7-0.2c1.2-1.8-0.1-4.5-2.7-6.2 C291.4,242.6,288.3,242.7,287.2,244.4z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214,560.7c0-0.5,0.1-0.9,0.2-1.4c0.6-3.7,2.8-2.9,4.3-2.5c0.3,0.1,1.2,0.3,2.4,0.6 c1.3-0.3,2.2-0.6,2.4-0.6c1.5-0.4,3.7-1.3,4.3,2.5c0.1,0.4,0.1,0.8,0.2,1.4c0.3,5.3,0.5,6.9,0.5,6.9s-3.2,0-7.4,0 c-4.2,0-7.4,0-7.4,0S213.7,566,214,560.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.9,268.9c0,0-11.1-12.6-13.7-16.8c-1.9-3.1,2.6-5.3,5.3-6.8c2.7-1.5,13.1,3.7,20,10.5 C227.9,261,212.3,269.2,210.9,268.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.8,320c-11-2.1-54.1-43.3-54.1-43.3s1-5.6,6-13.3c7.3-11.4,13-13.1,13-13.1s31.6,10.5,49.8,21.5 C276.7,284.3,266,322.5,252.8,320z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.2,188.9c1.8-0.2,6.9-0.7,7,0.9c0.2,3.3-9.4,6.3-13.1,6.5c-2.7,0.2,0-3.1,0-3.1 S227.6,189.3,231.2,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.4,246.5c1.6-16.6,19.2-46.3,23-55c-0.3-4.9,0.1-7.2,1.8-13.3c1-3.9,5.9-7.2,14.3,3 c1.5,1.7,0.3,11.9-9.3,13.8c-3.5,2.9-10.9,36.8-13.6,47.9c-1.3,5-3.7,12.4-7.4,12.4C199.1,255.3,195.8,252.7,196.4,246.5z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "292,7.4 324.9,74.3 398.7,85 345.3,137 357.9,210.6 292,175.8 226,210.6 238.6,137 185.2,85  259,74.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.6,322.6c0,0,10.6,7.9,15.4,10c3.5,1.6,9.2-1.5,10.4-4.5c1.2-3-5.5-13.2-13.6-19.5 C144.5,303.8,137.9,321.1,138.6,322.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.2,292.1c12,25.7,33.9,41.1,33.9,41.1s7.1-1.4,13-8.9c5.2-6.9,5.3-11.5,5.3-11.5s-16.5-19.8-25.2-36.6 c-2.4-4.8-10.9-19.1-18.5-15.5C107.6,264.9,100.3,275.1,108.2,292.1z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.4,259.1c0,0,6.3-3.8,6.6-8.8c0.3-5.1-2.7-6.7-1.8-8.4c1.7-3.1,1.4-12.9-1.2-18.4 c-3.3-7.3-7.1-16.3-29.6-14c-14,1.5-23,19.6-29.2,45.7c-2.9,12.2-16.5,12.2-24.4,13.6c-14.3,2.5-18.5,15.1-18.1,26.1 c0.4,9.3,6.6,10,6.6,11.6c0.1,4.3-3.6,21.2,26.4,30.7c16.7,5.3,37.2,7,61-7.9s20.4-41.1,14-51.1 C119.4,268.1,115.4,259.1,115.4,259.1z"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.3,553.8c0,0-22.4,3.3-24.1,3.6c-1.9,0.2-4.8,0.3-2.8,5.9c2,5.4,2.5,7.2,2.5,7.2s23.4-9.8,25.8-11.2 C207.1,557.8,208.2,555.1,203.3,553.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2044.5859,
    y1: -1351.2736,
    x2: 1950.5566,
    y2: -1539.3325,
    gradientTransform: "matrix(-0.9455 -0.3258 0.3258 -0.9455 2499.1982 -242.946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#101E2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#082947"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.8,351.3c0,0,13.7,71,15.9,85.3s-24.5,23-35.8,6.3c-11.4-16.7-26.7-40.2-30.6-58.8 c-4-18.6-2.5-33.8,8.6-47.6C118,322.8,145.2,332.2,148.8,351.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2498.2075,
    y1: -347.4139,
    x2: 2404.1729,
    y2: -535.4838,
    gradientTransform: "matrix(-0.989 -0.1479 0.1479 -0.989 2645.5388 396.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#101E2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#082947"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M164.8,435.4c3.2,17.8,2.1,18.1,5.3,39.8c3.3,21.6,13.2,84.1,13.2,84.1s-1.2,1.9-2.9,2.2 c-2.7,0.3-3.5-1-3.5-1s-3.8-15.2-9-24.5c-5.2-9.3-32.1-69.1-37.1-81.2c-5-12-4.5-22.6,9.6-27.2 C154.6,423,163.4,427.7,164.8,435.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.4,377.1c0,0-10.6,71.5-13.2,85.8c-2.7,14.2-30.6,13.6-35.9-5.9c-5.2-19.6-11.9-46.6-9.5-65.6 c2.3-18.9,8.7-32.7,23.7-42.1C100.6,339.8,123.2,357.7,120.4,377.1z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128.2,272.6c-1.9-13-5.1-14.4-24-12.4c-5.5,0.6-9.6,1.7-14.9,2.5c-18.1,2.9-23.1,3.1-23.6,23.3 c-1,39.2-5.1,102.2-5.1,102.2s14.7,9.1,58.2,4.9c36-3.5,42.6-13.2,42.6-13.2s-8.8-28-20.9-54.3c7.7-3.7,15.4-10.8,14.9-17.4 C153.9,294.6,131.5,294.7,128.2,272.6z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.9,259.4c-7.9,1.5-17.5-1.3-17.5,4.4c0,5.6,8.6,25.7,22,29.9c13.4,4.3,22.7-2.3,21-9 c-1.7-6.7-5.3-13.5-7.4-18.6s-0.6-10.7-6.3-9.7C104.1,257.2,102.4,258.6,97.9,259.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.2,260.1c-5.5,0.6-9.6,1.7-14.9,2.5c-1.6,0.2-3,0.5-4.4,0.7c2.4,7.7,10.9,31.9,28.4,27 c13.3-3.8,3.3-6.8-2.7-30.9C108.7,259.6,106.6,259.8,104.2,260.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.5,264.7c-1.5-10.2,2.6-17.9,4.7-28.3c-0.1-0.4,16.1-2.3,18.6-10.5c0,0,2.7,9.6,2.8,18.1 c0,7.9-1.6,12.4-9.7,10.1c-0.9,4.6-1.3,5.9-1.2,6.5c1.9,6.5-0.4,13-3.6,13.9C99.1,275.4,92.2,277.1,90.5,264.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.5,238.8c-0.8,2,0.9,4.6,4,5.9c3,1.2,6.1,0.5,6.9-1.6c0.8-2-0.9-4.6-4-5.9 C92.3,236.1,89.2,236.8,88.5,238.8z"
  }))))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.9,341.3c-17.6-2.8-8.7-23-8.7-23s-3.9,11.7,3.6,16.1c7.4,4.4,35.2-2.3,55.3-9c1,2.2,2,4.3,3,6.5 C131.2,335.6,103.3,343.5,89.9,341.3z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.3,562.9c0-0.5-0.1-1-0.2-1.5c-0.7-4-3-3.1-4.6-2.6c-0.3,0.1-1.3,0.3-2.6,0.7c-1.4-0.3-2.3-0.6-2.6-0.7 c-1.6-0.5-4-1.4-4.6,2.6c-0.1,0.4-0.1,0.9-0.2,1.5c-0.3,5.6-0.5,7.4-0.5,7.4s3.5,0,7.9,0s7.9,0,7.9,0S98.7,568.6,98.3,562.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.5,446.6c-4.4,32-16,115.2-16,115.2s-0.4,0.9-3.1,0.5c-2.6-0.4-3-2-3-2s0.1-14.2-2.5-24.4 c-2.6-10.1-9.9-57-11.7-69.7s-2-39,12.4-39.8C100.2,425.7,110.5,438.9,109.5,446.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,307c0,0-6.7,11.4-8.3,16.4c-1.2,3.7,2.4,9,5.5,9.7c3.1,0.7,12.4-6.9,17.9-15.7 C50.5,310.9,32.5,306.2,31.3,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.3,273.3c-24.3,14.7-36.6,36.9-36.6,36.9s2.1,7,10.2,11.9c7.4,4.5,12,4,12,4s11.5-8.2,26.6-19.8 c6.6-5.1,9.1-34.7,1.8-40C69,268.2,63.8,270.6,59.3,273.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95,321h92.2c3,0,5.6,2.5,5.6,5.6v77.2c0,3-2.5,5.6-5.6,5.6h-21.9h-3.5l0,0l-18.1,18.1 c-0.7,0.7-1.8,1.2-2.8,1.2c-1,0-2.1-0.4-2.8-1.2l-18.1-18.1H95.5l0,0h-0.9c-3-0.1-5.4-2.6-5.4-5.6v-77.2 C89.4,323.6,91.9,321,95,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.2,345.2c7.4-7.4,19.5-7.4,26.9,0l1,1l1-1c7.4-7.4,19.5-7.4,26.9,0c7.4,7.4,7.4,19.5,0,26.9l-1,1 L141.1,400l-26.9-26.9l-1-1C105.7,364.6,105.7,352.5,113.2,345.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.2,347.8c-1.8-2.5-4-4.9-5.6-4.2c-2.6,1,0.6,4.3,1,9.6c0.2,3.5,6.8,4.6,6.8,4.6 S200.1,351.6,197.2,347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.5,356.2c-0.5-5.2-6.6-10.8-14.2-3.9c-3,2.6-2.2,13,1.5,15.3c2.9,1.8,8.3,3.6,11.3-0.1 C200.3,364.9,199.9,359.4,199.5,356.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.6,326.2c1.9-6.1,4.7-6.1,10.8-3.6c17.9,6.2,34.4,27.2,46.4,34.4l-5.2,4.3c-6.8-5.1-32.7-18.1-42.3-24 C28.5,334.5,22.5,330,23.6,326.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.2,349.2c2.7-1.4,5.8-2.5,6.9-1.2c1.9,2.2-2.6,3.6-5.4,8.1c-1.9,2.9-8.2,0.8-8.2,0.8 S81.9,351.3,86.2,349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.9,355.9c6-0.9,13.8-10.1,19.6-1.6c2.2,3.3-1,13.2-5.2,14.4c-3.2,1-13.9-1.5-15.8-6 c-0.4-0.1-2.4-1-4.2-2.3l3.3-5.4C78.6,355.7,79.4,355.9,79.9,355.9z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M652.1,26.7h-98.9c-4.2,0-7.6,6-7.6,13.3v56.9c0,7.3,3.4,13.2,7.6,13.3h99.2c4-0.3,7.2-6.1,7.2-13.2V40.1 C659.7,32.7,656.3,26.7,652.1,26.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M636.3,63.1v-0.6c0-2.3-1.9-4.3-4.3-4.3h-2.5h-2.3c-1.7,0-4,0-5,0c-0.1,0-0.3,0-0.4,0c0,0,0,0-0.1,0 c-1.6,0-2.1-0.1-1.4-1.3c0.7-1.2,4.8-6.8,5.2-11.5s-1.5-7.7-4.8-7.7s-3,3.9-5.6,8.8c-2.7,5-10.1,10.7-11.8,12.2s-2.9,2.4-2.9,4 c0,0,0,17.1,0,22.3c0,1.1,1.4,2.4,3.3,2.4c4.9,0,16.4,0,22.2,0h3.6h0.1c1.8,0,3.2-1.5,3.2-3.2v-0.4c0-0.8-0.3-1.6-0.8-2.2 c1.5-0.3,2.7-1.6,2.7-3.2V78c0-1.4-0.9-2.6-2.2-3c1.8-0.2,3.1-1.8,3.1-3.6V71c0-2-1.6-3.6-3.6-3.6l0,0 C634.4,67.4,636.3,65.4,636.3,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M597.1,60.8h-9.2c-0.9,0-1.6,0.7-1.6,1.6v23.5c0,0.9,0.7,1.6,1.6,1.6h9.2c0.9,0,1.6-0.7,1.6-1.6V62.5 C598.8,61.6,598,60.8,597.1,60.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 558.8,
    y: 34.3,
    className: "st14",
    width: 2.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M561.2,85.4h-2.3V74.1h2.3V85.4z M561.2,62.8h-2.3V51.5h2.3V62.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 558.8,
    y: 96.7,
    className: "st14",
    width: 2.3,
    height: 5.8
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M499.5,200H438c-2.6,0-4.7,3.7-4.7,8.2v35.4c0,4.5,2.1,8.2,4.7,8.2h61.7c2.5-0.2,4.5-3.8,4.5-8.2v-35.4 C504.2,203.7,502.1,200,499.5,200z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M489.6,222.6v-0.4c0-1.5-1.2-2.6-2.6-2.6h-1.6H484c-1.1,0-2.5,0-3.1,0c-0.1,0-0.2,0-0.3,0l0,0 c-1,0-1.3-0.1-0.9-0.8c0.4-0.8,3-4.2,3.3-7.2c0.3-2.9-0.9-4.8-3-4.8c-2,0-1.8,2.4-3.5,5.5s-6.3,6.7-7.3,7.6 c-1.1,0.9-1.8,1.5-1.8,2.5c0,0,0,10.7,0,13.9c0,0.7,0.9,1.5,2.1,1.5c3.1,0,10.2,0,13.8,0h2.2h0.1c1.1,0,2-0.9,2-2v-0.3 c0-0.5-0.2-1-0.5-1.3c0.9-0.2,1.7-1,1.7-2v-0.3c0-0.9-0.6-1.6-1.3-1.9c1.1-0.1,2-1.1,2-2.2v-0.3c0-1.2-1-2.3-2.3-2.3l0,0 C488.4,225.2,489.6,224,489.6,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M465.3,221.2h-5.7c-0.6,0-1,0.5-1,1v14.6c0,0.6,0.5,1,1,1h5.7c0.6,0,1-0.5,1-1v-14.6 C466.3,221.6,465.8,221.2,465.3,221.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 204.7,
    className: "st14",
    width: 1.4,
    height: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M442.9,236.4h-1.4v-7h1.4V236.4z M442.9,222.4h-1.4v-7h1.4V222.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 243.5,
    className: "st14",
    width: 1.4,
    height: 3.6
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M520.5,287.7H459c-2.6,0-4.7,3.7-4.7,8.2v35.4c0,4.5,2.1,8.2,4.7,8.2h61.7c2.5-0.2,4.5-3.8,4.5-8.2v-35.4 C525.2,291.4,523.1,287.7,520.5,287.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M510.6,310.3v-0.4c0-1.5-1.2-2.6-2.6-2.6h-1.6H505c-1.1,0-2.5,0-3.1,0c-0.1,0-0.2,0-0.3,0l0,0 c-1,0-1.3-0.1-0.9-0.8c0.4-0.8,3-4.2,3.3-7.2c0.3-2.9-0.9-4.8-3-4.8c-2,0-1.8,2.4-3.5,5.5s-6.3,6.7-7.3,7.6 c-1.1,0.9-1.8,1.5-1.8,2.5c0,0,0,10.7,0,13.9c0,0.7,0.9,1.5,2.1,1.5c3.1,0,10.2,0,13.8,0h2.2h0.1c1.1,0,2-0.9,2-2v-0.3 c0-0.5-0.2-1-0.5-1.3c0.9-0.2,1.7-1,1.7-2v-0.3c0-0.9-0.6-1.6-1.3-1.9c1.1-0.1,2-1.1,2-2.2v-0.3c0-1.2-1-2.3-2.3-2.3l0,0 C509.4,312.9,510.6,311.7,510.6,310.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M486.3,308.9h-5.7c-0.6,0-1,0.5-1,1v14.6c0,0.6,0.5,1,1,1h5.7c0.6,0,1-0.5,1-1v-14.6 C487.3,309.3,486.9,308.9,486.3,308.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 462.5,
    y: 292.4,
    className: "st14",
    width: 1.4,
    height: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M463.9,324.2h-1.4v-7h1.4V324.2z M463.9,310.1h-1.4v-7h1.4V310.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 462.5,
    y: 331.2,
    className: "st14",
    width: 1.4,
    height: 3.6
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.6248,
    y1: 238.4326,
    x2: 729.6248,
    y2: -69.4481,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#084482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    style: {
      stopColor: "#053360"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03294C"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M928.6,324.7H592.7c-4.3,0-8.7,3.6-9.6,7.9L534,552.5c-1,4.3-5.3,7.9-9.6,7.9h351.5c4.3,0,8.7-3.6,9.6-7.9 l49.2-219.9C935.6,328.3,932.9,324.7,928.6,324.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M550.7,548.5c-2.1,0-3.6-1.7-3.1-3.9l43.1-192.5c0.5-2.1,2.6-3.9,4.8-3.9h320.1c2.1,0,3.6,1.7,3.1,3.9 l-43.1,192.4c-0.5,2.1-2.6,3.9-4.8,3.9L550.7,548.5L550.7,548.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1081.7545,
    y1: 224.6117,
    x2: 1154.0807,
    y2: 161.771,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M879.5,390.4c-4.7,21.1-25.6,38.1-46.7,38.1s-34.3-17.1-29.6-38.1c4.7-21.1,25.6-38.1,46.7-38.1 S884.2,369.4,879.5,390.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M832.8,428.6c21.1,0,42-17.1,46.7-38.1h-38.1L832.8,428.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1071.6149,
    y1: 111.784,
    x2: 1071.6149,
    y2: 59.1352,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M807.7,435.6h-10.2c-0.7,0-1.3,0.6-1.5,1.2l-23.2,103.8h12.6l23.2-103.8 C808.8,436.1,808.4,435.6,807.7,435.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1149.7422,
    y1: 66.7304,
    x2: 1149.7422,
    y2: 58.5537,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M866,524.2h-10.2c-0.7,0-1.3,0.6-1.5,1.2l-3.4,15.1h12.6l3.4-15.1C867.1,524.8,866.7,524.2,866,524.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1130.1633,
    y1: 73.651,
    x2: 1130.1633,
    y2: 58.643,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M849.5,510.7h-10.2c-0.7,0-1.3,0.6-1.5,1.2l-6.4,28.7h12.6l6.4-28.7C850.6,511.2,850.1,510.7,849.5,510.7z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.1864,
    y1: 98.8001,
    x2: 1091.1864,
    y2: 58.9677,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M821.5,461.1h-10.2c-0.7,0-1.3,0.6-1.5,1.2l-17.4,78.2H805l17.5-78.2C822.6,461.6,822.2,461.1,821.5,461.1 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1110.6936,
    y1: 85.4219,
    x2: 1110.6936,
    y2: 58.795,
    gradientTransform: "matrix(1 0 0.2238 -1 -305.5791 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M835.2,487.4H825c-0.7,0-1.3,0.6-1.5,1.2l-11.6,51.9h12.6l11.6-51.9C836.2,488,835.8,487.4,835.2,487.4z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M866.9,540.6h-3.4H863h-94.1c-1.7,0-2.7-1.3-2.3-3l17.8-79.5l0.3-1.6l0.5-2.2c0.1-0.4-0.2-0.7-0.6-0.7h-2.1 c-0.4,0-0.8,0.3-0.9,0.7l-0.5,2.2l-0.3,1.6L763,537.6c-0.8,3.6,1.5,6.6,5.1,6.6h94.2h0.5h3.4c0.4,0,0.8-0.3,0.9-0.7l0.5-2.1 C867.6,540.9,867.3,540.6,866.9,540.6z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M768.6,331.5c3.2,0,5.3,2.6,4.5,5.8c-0.7,3.2-4,5.8-7.2,5.8h-18.9c-3.2,0-5.3-2.6-4.5-5.8c0.7-3.2,4-5.8,7.2-5.8H768.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M768.1,333.4c-2.1,0-4.3,1.7-4.8,3.9c-0.5,2.1,0.9,3.9,3.1,3.9c2.1,0,4.3-1.7,4.8-3.9 C771.7,335.1,770.3,333.4,768.1,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M749.3,333.4c-2.1,0-4.3,1.7-4.8,3.9c-0.5,2.1,0.9,3.9,3.1,3.9s4.3-1.7,4.8-3.9 C752.8,335.1,751.4,333.4,749.3,333.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M748.8,335.5c-1,0-2,0.8-2.2,1.8c-0.2,1,0.4,1.8,1.4,1.8c1,0,2-0.8,2.2-1.8 C750.4,336.3,749.8,335.5,748.8,335.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M766.6,340.1c-1.6,0-2.6-1.2-2.2-2.8c0.3-1.6,1.9-2.8,3.5-2.8c1.6,0,2.6,1.2,2.2,2.8 C769.8,338.9,768.2,340.1,766.6,340.1z M767.8,334.9c-1.3,0-2.7,1.1-3,2.4c-0.3,1.3,0.6,2.4,1.9,2.4s2.7-1.1,3-2.4 C770,336,769.2,334.9,767.8,334.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M767.6,336c-0.7,0-1.5,0.6-1.7,1.3c-0.2,0.7,0.3,1.3,1.1,1.3c0.7,0,1.5-0.6,1.7-1.3 C768.8,336.5,768.4,336,767.6,336z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 781.0428,
    y1: 32.8211,
    x2: 316.9045,
    y2: 32.8211,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#084482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    style: {
      stopColor: "#053360"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03294C"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M759.6,568.1v-3.9c0-2.1,1.7-3.9,3.9-3.9H420.3c-2.1,0-3.9,1.7-3.9,3.9v3.9c0,2.1,1.7,3.9,3.9,3.9h343.2 C761.3,572.1,759.6,570.3,759.6,568.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 915.9694,
    y1: 220.5152,
    x2: 760.5036,
    y2: -103.765,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#084482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    style: {
      stopColor: "#053360"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03294C"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M942.1,338.3c-0.2-0.4-7-9.3-7.4-9.7c-0.2-0.4-0.5-0.7-0.8-1.1c0.8,1.3,1.1,3.1,0.7,5l-49.2,219.9 c-1,4.3-5.3,7.9-9.6,7.9H763.6c-2.1,0-3.9,1.7-3.9,3.9v3.9c0,2.1,1.7,3.9,3.9,3.9h121.3c4.3,0,8.7-3.6,9.6-7.9l49.2-219.9 C944.1,341.9,943.5,339.8,942.1,338.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.9355,
    y1: 67.4009,
    x2: 589.9355,
    y2: -40.607,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M433.8,560.3h308.3v-1.2c0-2.1,1.7-3.9,3.9-3.9H437.7c-2.1,0-3.9,1.7-3.9,3.9V560.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.1547,
    y1: 50.3253,
    x2: 457.1547,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M459.8,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C455.8,557,457.7,555.1,459.8,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.2297,
    y1: 50.3253,
    x2: 479.2297,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M481.9,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C478,557,479.7,555.1,481.9,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.3874,
    y1: 50.3253,
    x2: 501.3874,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M504,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C500.1,557,501.9,555.1,504,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 523.5451,
    y1: 50.3253,
    x2: 523.5451,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M526.2,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C522.2,557,524,555.1,526.2,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.6201,
    y1: 50.3253,
    x2: 545.6201,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M548.3,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C544.4,557,546.1,555.1,548.3,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.7778,
    y1: 50.3253,
    x2: 567.7778,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M570.4,555.1H569c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C566.5,557,568.3,555.1,570.4,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.8528,
    y1: 50.3253,
    x2: 589.8528,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M592.5,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C588.6,557,590.3,555.1,592.5,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 612.0106,
    y1: 50.3253,
    x2: 612.0106,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M614.7,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C610.8,557,612.5,555.1,614.7,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.1683,
    y1: 50.3253,
    x2: 634.1683,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M636.8,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C632.8,557,634.7,555.1,636.8,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.2433,
    y1: 50.3253,
    x2: 656.2433,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M658.9,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C655,557,656.7,555.1,658.9,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 678.401,
    y1: 50.3253,
    x2: 678.401,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M681,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C677.1,557,678.9,555.1,681,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 700.5587,
    y1: 50.3253,
    x2: 700.5587,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M703.2,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C699.2,557,701,555.1,703.2,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.6337,
    y1: 50.3253,
    x2: 722.6337,
    y2: 36.9265,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M725.3,555.1h-1.4c-2.1,0-3.9,1.7-3.9,3.9v1.2h1.4V559C721.4,557,723.1,555.1,725.3,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 800.4337,
    y1: 67.4009,
    x2: 800.4337,
    y2: -40.607,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#FCB200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    style: {
      stopColor: "#FA7E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F96A00"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M854.8,555.1H746c-2.1,0-3.9,1.7-3.9,3.9v1.2h116.6V559C858.7,557,856.9,555.1,854.8,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 878.4061,
    y1: 41.3382,
    x2: 688.5953,
    y2: 41.3382,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M854.8,555.1H746c-2.1,0-3.9,1.7-3.9,3.9v1.2h116.6V559C858.7,557,856.9,555.1,854.8,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -3068.3279,
    y1: 50.3253,
    x2: -3068.3279,
    y2: 36.9265,
    gradientTransform: "matrix(-1 0 0 -1 -2305.2646 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M760.4,555.1h1.4c2.1,0,3.9,1.7,3.9,3.9v1.2h-1.4V559C764.3,557,762.6,555.1,760.4,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -3091.8911,
    y1: 50.3253,
    x2: -3091.8911,
    y2: 36.9265,
    gradientTransform: "matrix(-1 0 0 -1 -2305.2646 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M784,555.1h1.4c2.1,0,3.9,1.7,3.9,3.9v1.2h-1.4V559C787.9,557,786.2,555.1,784,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -3115.5371,
    y1: 50.3253,
    x2: -3115.5371,
    y2: 36.9265,
    gradientTransform: "matrix(-1 0 0 -1 -2305.2646 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M807.6,555.1h1.4c2.1,0,3.9,1.7,3.9,3.9v1.2h-1.4V559C811.5,557,809.8,555.1,807.6,555.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -3139.1003,
    y1: 50.3253,
    x2: -3139.1003,
    y2: 36.9265,
    gradientTransform: "matrix(-1 0 0 -1 -2305.2646 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M831.2,555.1h1.4c2.1,0,3.9,1.7,3.9,3.9v1.2h-1.4V559C835.2,557,833.3,555.1,831.2,555.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M851.2,567.9c0,0.6-0.4,1-1,1h-15.1c-0.6,0-1-0.4-1-1v-3.4c0-0.6,0.4-1,1-1h15.1c0.6,0,1,0.4,1,1V567.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 842.6409,
    y1: 47.6762,
    x2: 842.6409,
    y2: 26.6598,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M850.2,563.5h-15.1c-0.6,0-1,0.4-1,1v1.1c0,0.6,0.4,1,1,1h15.1c0.6,0,1-0.4,1-1v-1.1 C851.2,563.9,850.8,563.5,850.2,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M829.2,567.9c0,0.6-0.4,1-1,1h-15.1c-0.6,0-1-0.4-1-1v-3.4c0-0.6,0.4-1,1-1h15.1c0.6,0,1,0.4,1,1V567.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 820.6485,
    y1: 47.6762,
    x2: 820.6485,
    y2: 26.6598,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M828.3,563.5h-15.2c-0.6,0-1,0.4-1,1v1.1c0,0.6,0.4,1,1,1h15.1c0.6,0,1-0.4,1-1v-1.1 C829.2,563.9,828.8,563.5,828.3,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M807.5,566.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2C806.4,568.5,807.5,567.4,807.5,566.2 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 805.1464,
    y1: 36.3199,
    x2: 805.1464,
    y2: 30.2091,
    gradientTransform: "matrix(1 0 0 -1 0 599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M806.4,566.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2 C805.9,567.4,806.4,566.9,806.4,566.2z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M555.1,538.6h185.6L781,360H595.4L555.1,538.6z M638.6,437.2l-0.6,2.6h-35l0.6-2.6H638.6z M605.6,428.3 l0.6-2.6h6.2l-0.6,2.6H605.6z M654.3,406.7l-0.6,2.6h-36l0.6-2.6H654.3z M619.7,400.7l0.6-2.6h23l-0.6,2.6H619.7z M646.8,400.7 l0.6-2.6h8.9l-0.6,2.6H646.8z M668.9,416.9l-0.6,2.6h-52.8l0.6-2.6H668.9z M667,406.7l-0.6,2.6h-9.3l0.6-2.6H667z M659.1,400.7 l0.6-2.6h9.3l-0.6,2.6H659.1z M628.5,492.2h23l-0.6,2.6h-23L628.5,492.2z M627.2,481.1l0.6-2.6h6.2l-0.6,2.6H627.2z M624.6,452 l-0.6,2.6h-12.2l0.6-2.6H624.6z M610.2,462.1h32l-0.6,2.6h-32L610.2,462.1z M620.9,469.6l-0.6,2.6h-12.2l0.6-2.6H620.9z  M598.1,516.5h12.2l-0.6,2.6h-12.2L598.1,516.5z M613.5,528h-17.9l0.6-2.6h17.9L613.5,528z M624.1,481.1h-17.9l0.6-2.6h17.9 L624.1,481.1z M622.8,528h-6.2l0.6-2.6h6.2L622.8,528z M636.9,513.5h-13.3l0.6-2.6h13.3L636.9,513.5z M654.3,513.5h-13.5l0.6-2.6 h13.5L654.3,513.5z M656.2,504.7h-30.7l0.6-2.6h30.7L656.2,504.7z M711.8,419.5h-40.5l0.6-2.6h40.5L711.8,419.5z M700.8,492.2 l-0.6,2.6H682l0.6-2.6H700.8z M677.2,492.2l-0.6,2.6h-9.3l0.6-2.6H677.2z M664.4,492.2l-0.6,2.6h-8.9l0.6-2.6H664.4z M689.7,513.5 h-32.2l0.6-2.6h32.2L689.7,513.5z M700.5,513.5h-7.8l0.6-2.6h7.8L700.5,513.5z M702.5,504.7h-43l0.6-2.6h43L702.5,504.7z  M724,409.5h-52.2l0.6-2.6h52.2L724,409.5z M673.9,400.7l0.6-2.6h18.2l-0.6,2.6H673.9z M668.3,390.5h52.2l-0.6,2.6h-52.2 L668.3,390.5z M653.5,390.5h9.3l-0.6,2.6h-9.3L653.5,390.5z M649.5,393.3h-36l0.6-2.6h36L649.5,393.3z M615.5,384.4l0.6-2.6h6.2 l-0.6,2.6H615.5z M635.6,364.2h8.3l-0.6,2.6H635L635.6,364.2z M598.9,364.2h32l-0.6,2.6h-32L598.9,364.2z M597,373h12.2l-0.6,2.6 h-12.2L597,373z M595,381.8h17.9l-0.6,2.6h-17.9L595,381.8z M585.1,425.7h18l-0.6,2.6h-17.9L585.1,425.7z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M993.3,572.5H-30.6c-0.6,0-1-0.5-1-1s0.5-1,1-1H993.3c0.6,0,1,0.5,1,1S993.9,572.5,993.3,572.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinningTalents01);
export default __webpack_public_path__ + "static/media/winning_talents-01.2092a2e0ec20cbed3859b020fd1c396d.svg";
export { ForwardRef as ReactComponent };